import { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import {CommonService} from "../services";

const useSystemLockUpdateLabOs = () => {
    const [allowUpdate, setAllowUpdate] = useState(true);

    const handleIframeMessage = useCallback((event:any) => {
        // console.log(event, "this is the event");
        if (event?.data?.source === "lab-os-streamlit" && allowUpdate) {
            CommonService._communications.UpdateLastActivityTimeSubject.next(moment().unix());

            // Set a timer to disallow update for 1 second
            setAllowUpdate(false);
            setTimeout(() => {
                setAllowUpdate(true);
            }, 1000); // Adjust delay (1000ms = 1 second)
        }
    }, [allowUpdate]);

    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, [handleIframeMessage]);

    return null;
};

export default useSystemLockUpdateLabOs;
